/**
 * Functin to check variable/object types
 * @param {*} o - variable to have checked
 * @returns {boolean} - true/false
 */
export const checkType = o => ({
  getType: function() {
    return Object.prototype.toString
      .call(o)
      .split(' ')[1]
      .replace(']', '');
  },
  isArray: function() {
    return this.getType() === 'Array';
  },
  isObject: function() {
    return this.getType() === 'Object';
  },
  isBoolean: function() {
    return this.getType() === 'Boolean';
  },
  isString: function() {
    return this.getType() === 'String';
  },
  isFunction: function() {
    return this.getType() === 'Function';
  },
  isNumber: function() {
    return this.getType() === 'Number';
  }
});



// WEBPACK FOOTER //
// ./src/utils/checkType.js